export default __webpack_public_path__ + "static/media/How_to_find_post_url.66d3d4e4.png";